import { takeLatest, put } from "redux-saga/effects";
import { SET_LANGUAGE } from "./types";
import { setLanguageSuccess, setLanguageFailure } from "./actions";

// Worker saga: performs the actual language change side effects
function* handleSetLanguage(action: any) {
  try {
    // Dispatch success action with the selected language
    yield put(setLanguageSuccess(action.payload));
  } catch (error) {
    // If something goes wrong, dispatch failure action
    yield put(setLanguageFailure("Failed to change language"));
  }
}

// Watcher saga: listens for the SET_LANGUAGE action
function* languageSaga() {
  yield takeLatest(SET_LANGUAGE, handleSetLanguage);
}

export default languageSaga;
